import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from '@ngrx/store';
import { of } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";
import { QuestionnaireService, SysParamService } from "src/app/api/services";
import { AppState } from 'src/app/state/app.state';
import * as QuestionActions from "./question.actions";

@Injectable()
export class QuestionEffects {
	constructor(private actions$: Actions, private questionService: QuestionnaireService,
		private store: Store<AppState>, private sysParamService: SysParamService) { }

	public loadQuestionList$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(QuestionActions.loadQuestionnaire),
			switchMap(({ insurerQuestionnaireId, profileQuestionnaireId, languageCode }) =>
				this.questionService.questionnaireGetQuestionnaireToPlay$Json({
					insurerQuestionnaireId: insurerQuestionnaireId, profileQuestionnaireId: profileQuestionnaireId,
					languageCode: languageCode
				}).pipe(
					map((data) => QuestionActions.loadQuestionnaireSuccess({ data: data })),
					catchError((err) => of(QuestionActions.loadQuestionnaireFailure({ error: err })))
				)
			)
		);
	});

	public validateAnswer$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(QuestionActions.validateAnswer),
			switchMap(({ validateAnswer }) =>
				this.questionService.questionnaireValidateAnswer$Json({body:validateAnswer}).pipe(
					map((data) => QuestionActions.validateAnswerSuccess({ data: data })),
					catchError((err) => of(QuestionActions.validateAnswerFailure({ error: err })))
				)
			)
		);
	});
}
